import { render, staticRenderFns } from "./AquariumGakkenView.vue?vue&type=template&id=06427789&scoped=true&"
import script from "./AquariumGakkenView.vue?vue&type=script&lang=js&"
export * from "./AquariumGakkenView.vue?vue&type=script&lang=js&"
import style0 from "./AquariumGakkenView.vue?vue&type=style&index=0&id=06427789&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06427789",
  null
  
)

export default component.exports